import React from 'react';
import Base from './Base';
import { Link } from 'react-router-dom';
import { AuthFooter } from './AuthFooter';

export default class Login extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            mobile: '',
            password: '',
            loading: true,
            passwordFieldType: 'password'
        };
        window.document.body.classList = "nk-body bg-white npc-general pg-auth";
    }
    login(e) {
        e.preventDefault();

        if (this.isBlank(this.state.mobile)) {
            this.showErorrMessage('شماره موبایل را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.password)) {
            this.showErorrMessage('کلمه عبور را وارد نمایید');
            return;
        }
        this.httpPost("api/v1/login/do", {
            mobile: this.state.mobile,
            password: this.state.password
        })
            .then(data => {
                if (data.status === 1) {
                    window.location.href = "/";
                }
                this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    componentDidMount() {
        this.httpPost("api/v1/login/get")
            .then(data => {
                if (data.logged == 1) window.location.href = "/";
                else {
                    this.setState({
                        data: data,
                        loading: false
                    });
                }
            });
    }
    changePasswordFieldType() {
        if (this.state.passwordFieldType == "password") this.setState({ passwordFieldType: "text" });
        else this.setState({ passwordFieldType: "password" });
    }
    renderForm() {
        return <div className="jumbotron vertical-center ng-scope" style={{ "margin-bottom": "0" }} >
            <div className="container">
                <div className="panel panel-primary center-block" style={{ "max-width": "400px" }} >
                    <div id="div-main">
                        <form onSubmit={e => this.login(e)} className="panel-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group input-group has-feedback" style={{ "width": "100%" }}>
                                        <input defaultValue={this.state.mobile} onChange={e => this.state.mobile = e.target.value} type="text" className="form-control input-lg ng-pristine ng-untouched ng-valid" dir="ltr" placeholder="شماره موبایل" />
                                        <i className="fa fa-envelope fa-fw form-control-feedback"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group input-group has-feedback" style={{ "width": "100%" }}>
                                        <input defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} type="password" className="form-control input-lg ng-pristine ng-untouched ng-valid ng-valid-maxlength" dir="ltr" maxlength="20" placeholder="کلمه عبور" />
                                        <i className="fa fa-lock fa-fw form-control-feedback"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-footer clearfix">
                                <button role="button" type="submit" className="btn btn-primary btn-lg btn-block">ورود</button>
                                <div className="text-center ng-hide" style={{ "margin-top": "20px" }}>
                                    <a href="/home/remember" style={{ "text-decoration": "none" }}>بازیابی کلمه عبور</a>
                                </div>
                            </div>
                            <div className="panel-footer clearfix ng-hide">
                                <div className="text-right small" style={{ "margin-top": "20px" }} >
                                    <a href="" className="txt-gray" style={{"text-decoration": "none"}}>فعال سازی حساب کاربری</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {contents}
            </div>
        );
    }
}